import { RouteStatus } from "@/types/route/route.common";
/**
 * Get color for route status
 */
export const getRouteStatusColor = (status) => {
    switch (status) {
        case RouteStatus.PLANNED:
            return "blue";
        case RouteStatus.IN_PROGRESS:
            return "orange";
        case RouteStatus.COMPLETED:
            return "green";
        case RouteStatus.CANCELLED:
            return "red";
        default:
            return "default";
    }
};
/**
 * Route-related messages for notifications
 */
export const ROUTE_MESSAGES = {
    SUCCESS: {
        CREATE: "Маршрут успешно создан",
        UPDATE: "Маршрут успешно обновлен",
        DELETE: "Маршрут успешно удален",
        CANCEL: "Маршрут отменён",
        ASSIGN_RESOURCES: "Ресурсы успешно назначены на маршрут",
    },
    ERROR: {
        CREATE: "Ошибка при создании маршрута",
        UPDATE: "Ошибка при обновлении маршрута",
        DELETE: "Ошибка при удалении маршрута",
        CANCEL: "Ошибка при отмене маршрута",
        LOAD: "Ошибка при загрузке маршрутов",
        LOAD_SINGLE: "Ошибка при загрузке маршрута",
        ASSIGN_RESOURCES: "Ошибка при назначении ресурсов",
    },
    CONFIRM: {
        DELETE: "Вы уверены, что хотите удалить этот маршрут?",
        CANCEL: "Маршрут будет переведён в статус Отменён. Все точки маршрута будут удалены. Заказы останутся без изменений и будут доступны для назначения в новые маршруты.",
    },
};
